/** @format */

import React, { useEffect, useState } from "react";
import { normativeService } from "../../Services/normative.service";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import SpinnerLoading from "../Common/SpinnerLoading";

const NormativeList = ({ productGuid, tenantId }) => {
  const { t: translator } = useTranslation();
  const [normatives, setNormatives] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    normativeService
      .getNormativeList(productGuid)
      .then((res) => {
        setNormatives(res.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
  }, []);

  const options = {
    sizePerPage: 50,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };
  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "name",
      text: translator("Name"),
      sort: true,
    },
    {
      dataField: "unitOfMeasureName",
      text: translator("EditItem-UnitOfMeasure"),
    },
  ];

  return (
    <div className="p-1 ml-1">
      <div className="container-fluid p-0">
        <div className="card-body mb-4">
          <ToolkitProvider
            keyField="guid"
            data={normatives}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <SearchBar
                  {...props.searchProps}
                  placeholder={translator("Search")}
                />
                <hr />

                {isLoading ? (
                  <SpinnerLoading />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    noDataIndication={translator("No-Data")}
                    pagination={paginationFactory(options)}
                  />
                )}
              </div>
            )}
          </ToolkitProvider>
        </div>
      </div>
    </div>
  );
};

export default NormativeList;
